/**
 * Requires
 */

import $ from 'jquery'

const sdown = window.matchMedia('(max-width: 1024px)')

/**
 * Initialisation
 */

export function initialise() {
  $('.menu-subnav').on('click', toggleHover)
  $('header').on('mouseenter', '.menu-items.has-children', toggleMenuActive)
  $('header').on('mouseleave', '.menu-items.has-children', toggleMenuInactive)

  mobileClickMenu()
}

function mobileClickMenu() {
  if (sdown.matches) {
    const $toggle = $('[data-menu]')

    $toggle.on('click', function(event) {
      const $this = $(this)
      const id = $this.data('menu')
      const $target = $('[data-menu-target="' + id + '"]')

      if ($target.length) {
        event.preventDefault()
        $this.toggleClass('open')
        $target.toggleClass('open')
      }
    })
  }
}

function toggleHover() {
  $('.menu-items').removeClass('hover')
  setTimeout(function() {
    $(document).on('mousemove', function() {
      $('.menu-items').addClass('hover')
    })
  }, 350)
}

function toggleMenuActive() {
  const $header = $('header')

  // bail if header is in "menu-open" state
  if ($header.hasClass('menu-open')) return

  const theme = $header.data('theme') || 'dark'

  if (theme === 'dark') {
    $header.removeClass('color-black').addClass('color-white')
  }
}

function toggleMenuInactive() {
  const $header = $('header')

  // bail if header is in "menu-open" state
  if ($header.hasClass('menu-open')) return

  const theme = $header.data('theme') || 'dark'

  if (theme === 'dark') {
    $header.removeClass('color-white').addClass('color-black')
  }
}
